import { Request } from 'express';
import type { NextApiRequest } from 'next';
import { STATIC_PATH_PATTERNS } from '../../constants';
import { FEATURE_TOGGLE_LIST } from '../../context/feature-toggles/feature-toggles.types';
import { isAviosOpco } from '../../utils/opco-utils';
import { COOKIES } from '../../types';
import {
  SILENT_LOGIN_FLAG_EXPIRY_TIME_IN_SECONDS,
  userAgentsSubstringToSkipSilentLogin,
} from './auth0.constants';
import { SessionMaybe } from './auth0.types';
import { getFeatureToggles, getOpco } from '../../utils/server-side-context';

export const getFormattedSilentLoginCookieFlag = (toggle: boolean) =>
  `${COOKIES.SH_SILENT_AUTH}=true;Path=/;Max-Age=${
    toggle ? SILENT_LOGIN_FLAG_EXPIRY_TIME_IN_SECONDS : 0
  }`;

export const isSilentLogin = (request: Request | NextApiRequest) =>
  request.cookies[COOKIES.SH_SILENT_AUTH] === 'true';

export const appSessionCookiesInRequest = (request: Request) =>
  Object.keys(request.cookies).some(
    cookieName =>
      cookieName.startsWith('appSession') || cookieName.startsWith('__session'),
  );

export const shouldRunSilentLoginForPath = (path?: string) =>
  !path ||
  ![...STATIC_PATH_PATTERNS, 'sitemap', 'api'].some(string =>
    path.includes(string),
  );

export const shouldRunSilentLoginForUserAgent = (userAgent?: string) => {
  const lowerCaseUserAgent = userAgent?.toLowerCase();

  return (
    !lowerCaseUserAgent ||
    !userAgentsSubstringToSkipSilentLogin().some(botUserAgent =>
      lowerCaseUserAgent.includes(botUserAgent),
    )
  );
};

export const shouldRunSilentLoginForAviosOpco = (
  request: Request,
  session: SessionMaybe,
) =>
  isAviosOpco(getOpco().opcoId) &&
  !session &&
  appSessionCookiesInRequest(request);

export const shouldRunSilentLoginForNonAviosOpco = (
  request: Request,
  session: SessionMaybe,
) =>
  !isAviosOpco(getOpco().opcoId) &&
  !session &&
  getFeatureToggles().includes(FEATURE_TOGGLE_LIST.TEMP_USE_SSO_ON_PAGE_LOAD) &&
  !isSilentLogin(request);
